import React, { PropsWithChildren } from 'react'

import { Checkbox } from './Checkbox'
import { Input } from './Input'
import { Select } from './Select'

type FieldComposition = React.FC<PropsWithChildren> & {
  Checkbox: typeof Checkbox
  Input: typeof Input
  Select: typeof Select
}

const Field: FieldComposition = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>
}

Field.Input = Input
Field.Checkbox = Checkbox
Field.Select = Select

export { Field }
export * from './types'
